import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import ComplianceStatusUI from './ComplianceStatusUI.js'

// CS file codes that require a MANUAL due date (no system-computed default).
// Only these three show the "Set due date" link.
export const CS_FILE_CODES_WITH_DUE_DATE = new Set([
  'net_metering_certificate',
  'pictures_of_purchased_assets',
  'cs_other',
])

class ComplianceStatusSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reuploadMode: false,
      selectedFile: null,
      selectedUser: null,
      //
      updateRemarksMode: false,
      selectedDate: null,
      selectedRemarks: null,
      templateCode: null,
      csFile: null,
      downloadRequested: false,
      downloadErrorList: [],
      //
      deleteFileMode: false,
      //
      cpCsStatusUpdateMode: false,
      selectedFileCode: null,
      //
      objectCode: null,
      objectId: null,
      createMode: false,
      selectedRemarksId: null,
      //
      internalStatusUpdateMode: false,
      //
      emailSendMode: false,
      cpEmailSendMode: false,
      //
      internalEmailSubmitted: false,
      //
      moveToCs: false,
      moveToCsMode: false,
      //
      selectedUserId: null,
      complianceDocsUploadMode: false,
      complianceDocs2UploadMode: false,
      selectedFileList: null,
      //
      downloadPOCounterPartyRequested: false,
      //
      csInternalMonitoringEmailSendMode: false,
      addCustomDocMode: false,
      addDsraCsMode: false,
      //
      // Set CS Due Date
      setDueDateMode: false,
      setDueDateFileCode: null,
      setDueDateFileTitle: null,
      //
      // Duplicate compliance docs from another loan in same account
      duplicateMode: false,
      // Director-level external status update
      directorStatusUpdateMode: false,
      directorStatusFileCode: null,
      directorStatusUserId: null,
      directorStatusDirectorName: null,
      directorStatusCurrentStatus: null,
    }
  }

  componentDidMount() {
    this.handleHashScroll()
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.fileUploadList && this.props.fileUploadList) ||
      (prevProps.fileUploadList && this.props.fileUploadList && prevProps.fileUploadList.length !== this.props.fileUploadList.length)
    ) {
      this.handleHashScroll()
    }
  }

  handleHashScroll = () => {
    if (typeof window === 'undefined' || !window.location || !window.location.hash || this.hasHandledHashScroll) {
      return
    }
    const hash = window.location.hash
    const cleanHash = hash.replace(/^#/, '').trim()
    let rowNum = '16'
    const numMatch = cleanHash.match(/\d+/)
    if (numMatch) {
      rowNum = numMatch[0]
    }
    const targetId = `cp-row-${rowNum}`

    const tryScroll = () => {
      if (this.hasHandledHashScroll) return
      const el = document.getElementById(targetId) || document.getElementById(cleanHash) || document.getElementById('cp-row-16')
      if (el) {
        this.hasHandledHashScroll = true
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        el.classList.add('compliance-target-highlight')
        const el17 = document.getElementById('cp-row-17')
        if (el17 && (rowNum === '16' || cleanHash.includes('17'))) {
          el17.classList.add('compliance-target-highlight')
        }
        setTimeout(() => {
          el.classList.remove('compliance-target-highlight')
          if (el17) el17.classList.remove('compliance-target-highlight')
        }, 3000)
      }
    }

    setTimeout(tryScroll, 150)
    setTimeout(tryScroll, 500)
    setTimeout(tryScroll, 1000)
  }

  render() {
    return (
      <ComplianceStatusUI
        context={this.props.context}
        loan={this.props.loan}
        compliance={this.props.compliance}
        remarksList={this.props.remarksList}
        fileUpload={this.props.fileUpload}
        fileUploadList={this.props.fileUploadList}
        selectedUser={this.state.selectedUser}
        selectedFile={this.state.selectedFile}
        reuploadMode={this.state.reuploadMode}
        onReuploadClick={this.onReuploadClick}
        onCancelClick={() => { this.setState({ reuploadMode: false }) }}
        onRefreshClick={this.props.onRefreshClick}
        //
        updateRemarksMode={this.state.updateRemarksMode}
        templateCode={this.state.templateCode}
        csFile={this.state.csFile}
        selectedDate={this.state.selectedDate}
        selectedRemarks={this.state.selectedRemarks}
        //
        downloadRequested={this.state.downloadRequested}
        downloadErrorList={this.state.downloadErrorList}
        onDownloadClick={this.onDownloadClick}
        //
        deleteFileMode={this.state.deleteFileMode}
        onFileDeleteClick={this.onFileDeleteClick}
        selectedFileName={this.state.selectedFileName}
        //
        cpCsStatusUpdateMode={this.state.cpCsStatusUpdateMode}
        onCpCsStatusUpdateClick={this.onCpCsStatusUpdateClick}
        onCpCsStatusCancelClick={() => { this.setState({ cpCsStatusUpdateMode: false }) }}
        selectedFileCode={this.state.selectedFileCode}
        //
        objectCode={this.state.objectCode}
        objectId={this.state.objectId}
        createMode={this.state.createMode}
        onCancelRemarksClick={() => { this.setState({ createMode: false, updateRemarksMode: false }) }}
        onCreateRemarksClick={this.onCreateRemarksClick}
        onUpdateRemarksClick={this.onUpdateRemarksClick}
        selectedRemarksId={this.state.selectedRemarksId}
        //
        internalStatusUpdateMode={this.state.internalStatusUpdateMode}
        onInternalStatusUpdateClick={this.onInternalStatusUpdateClick}
        onInternalStatusCancelClick={() => { this.setState({ internalStatusUpdateMode: false }) }}
        //
        emailSendMode={this.state.emailSendMode}
        onEmailSendClick={() => { (this.setState({ emailSendMode: true })) }}
        onEmailSendCancel={() => { (this.setState({ emailSendMode: false })) }}
        //
        cpEmailSendMode={this.state.cpEmailSendMode}
        onCPEmailSendClick={() => { (this.setState({ cpEmailSendMode: true })) }}
        onCPEmailSendCancel={() => { (this.setState({ cpEmailSendMode: false })) }}
        //
        internalEmailSubmitted={this.state.internalEmailSubmitted}
        onSendInternalEmailClick={() => { (this.setState({ internalEmailSubmitted: true })) }}
        onSendInternalEmailCancel={() => { (this.setState({ internalEmailSubmitted: false })) }}
        //
        internalCPEmailSubmitted={this.state.internalCPEmailSubmitted}
        onSendCPInternalEmailClick={() => { (this.setState({ internalCPEmailSubmitted: true })) }}
        onSendCPInternalEmailCancel={() => { (this.setState({ internalCPEmailSubmitted: false })) }}
        //
        onMoveToCsClick={this.onMoveToCsClick}
        moveToCs={this.state.moveToCs}
        moveToCsMode={this.state.moveToCsMode}
        onMoveToCsCancelClick={() => { this.setState({ moveToCsMode: false, selectedFileCode: null }) }}
        //
        complianceDocsUploadMode={this.state.complianceDocsUploadMode}
        onComplianceDocsUploadClick={this.onComplianceDocsUploadClick}
        onComplianceDocsUploadCancel={() => { this.setState({ complianceDocsUploadMode: false }) }}
        onComplianceDocsUpload={this.onComplianceDocsUpload}
        //
        selectedUserId={this.state.selectedUserId}
        complianceDocs2UploadMode={this.state.complianceDocs2UploadMode}
        onComplianceDocs2UploadClick={this.onComplianceDocs2UploadClick}
        onComplianceDocs2UploadCancel={() => { this.setState({ complianceDocs2UploadMode: false }) }}
        onComplianceDocs2Upload={this.onComplianceDocs2Upload}
        selectedFileList={this.state.selectedFileList}
        //
        onDownloadPOCounterParty={this.onDownloadPOCounterParty}
        downloadPOCounterPartyRequested={this.state.downloadPOCounterPartyRequested}
        //
        csInternalMonitoringEmailSendMode={this.state.csInternalMonitoringEmailSendMode}
        onInternalCSMonitoringEmailClick={() => { (this.setState({ csInternalMonitoringEmailSendMode: true })) }}
        onInternalCSMonitoringEmailCancel={() => { (this.setState({ csInternalMonitoringEmailSendMode: false })) }}
        //
        addCustomDocMode={this.state.addCustomDocMode}
        onAddCustomDocClick={() => { this.setState({ addCustomDocMode: true }) }}
        onAddCustomDocCancel={() => { this.setState({ addCustomDocMode: false }) }}
        //
        addDsraCsMode={this.state.addDsraCsMode}
        onAddDsraCsClick={() => { this.setState({ addDsraCsMode: true }) }}
        onAddDsraCsCancel={() => { this.setState({ addDsraCsMode: false }) }}
        // Set CS Due Date props
        setDueDateMode={this.state.setDueDateMode}
        setDueDateFileCode={this.state.setDueDateFileCode}
        setDueDateFileTitle={this.state.setDueDateFileTitle}
        onSetDueDateClick={this.onSetDueDateClick}
        onSetDueDateCancel={this.onSetDueDateCancel}
        //
        // Duplicate compliance docs from another loan
        duplicateMode={this.state.duplicateMode}
        onDuplicateClick={() => { this.setState({ duplicateMode: true }) }}
        onDuplicateCancel={() => { this.setState({ duplicateMode: false }) }}
        //
        // Director-level status update
        directorStatusUpdateMode={this.state.directorStatusUpdateMode}
        directorStatusFileCode={this.state.directorStatusFileCode}
        directorStatusUserId={this.state.directorStatusUserId}
        directorStatusDirectorName={this.state.directorStatusDirectorName}
        directorStatusCurrentStatus={this.state.directorStatusCurrentStatus}
        onDirectorStatusUpdateClick={this.onDirectorStatusUpdateClick}
        onDirectorStatusUpdateCancel={this.onDirectorStatusUpdateCancel}
      />
    )
  }

  onReuploadClick = (event) => {
    let rowId = event.currentTarget.getAttribute('data-row-id')
    let fileCode
    let userId = null

    if (rowId.includes('-')) { // director - level file
      let index = rowId.indexOf('-');
      fileCode = rowId.substr(0, index)
      userId = rowId.substr(index + 1, rowId.length - index - 1)
      console.log(fileCode, userId)
    }
    else {
      fileCode = rowId
    }

    let fileUploadList = this.props.loan.fileUploadList
    let selectedFile = fileUploadList.filter(f => f.fileCode === fileCode)
    if (!selectedFile.length) {
      fileUploadList = this.props.loan.fileUpload2List
      selectedFile = fileUploadList.filter(f => f.fileCode === fileCode)
    }
    if (!selectedFile.length) {
      fileUploadList = this.props.loan.fileUpload3List
      selectedFile = fileUploadList.filter(f => f.fileCode === fileCode)
    }

    let selectedUser = null
    if (userId) {
      let u = selectedFile[0].directorUploadList.filter(u => u.userId === userId)
      selectedUser = u[0]
    }

    this.setState({ selectedFile: selectedFile[0], selectedUser: selectedUser, reuploadMode: true })
  }

  onDownloadClick = (event) => {
    let fileCode = event.currentTarget.getAttribute('data-file-code')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    let objectCode = event.currentTarget.getAttribute('data-file-group')
    let userId = event.currentTarget.getAttribute('data-user-id')
    let path
    if (objectCode === 'cp') path = 'cpdocuments'
    if (objectCode === 'cs') path = 'csdocuments'
    if (objectCode === 'term_sheet') path = 'termSheet/files'
    this.setState({ downloadRequested: true })
    if (userId) {
      RestApiUtils.get(this.props.context,
        `/api/su/loans/${this.props.loan.loanId}/compliance/${fileCode}/${fileName}/users/${userId}/fileDownloadSignedUrl`,
        this.onDownloadClickCallback, null, null
      )
    }
    else {
      RestApiUtils.get(this.props.context,
        `/api/su/loans/${this.props.loan.loanId}/compliance/${fileCode}/${fileName}/fileDownloadSignedUrl`,
        this.onDownloadClickCallback, null, null
      )
    }
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
  onDirectorStatusUpdateClick = (event) => {
    const fileCode = event.currentTarget.getAttribute('data-code')
    const userId = event.currentTarget.getAttribute('data-user-id')
    const directorName = event.currentTarget.getAttribute('data-director-name')
    const currentStatus = event.currentTarget.getAttribute('data-current-status')
    this.setState({
      directorStatusUpdateMode: true,
      directorStatusFileCode: fileCode,
      directorStatusUserId: userId,
      directorStatusDirectorName: directorName,
      directorStatusCurrentStatus: currentStatus,
    })
  }

  onDirectorStatusUpdateCancel = () => {
    this.setState({
      directorStatusUpdateMode: false,
      directorStatusFileCode: null,
      directorStatusUserId: null,
      directorStatusDirectorName: null,
      directorStatusCurrentStatus: null,
    })
  }

  onFileDeleteClick = (event) => {
    let fileCode = event.currentTarget.getAttribute('data-code')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    let userId = event.currentTarget.getAttribute('data-user-id')
    this.setState({
      successMsg: null,
      errorList: [],
      deleteFileMode: true,
      selectedFileCode: fileCode,
      selectedFileName: fileName,
      selectedUserId: userId
    })
    if (userId) {
      RestApiUtils.delete(this.props.context,
        `/api/su/loans/${this.props.loan.loanId}/compliance/${fileCode}/${fileName}/users/${userId}`,
        this.onFileDeleteClickCallback, null, null
      )
    }
    else {
      RestApiUtils.delete(this.props.context,
        `/api/su/loans/${this.props.loan.loanId}/compliance/${fileCode}/${fileName}`,
        this.onFileDeleteClickCallback, null, null
      )
    }
  }

  onFileDeleteClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }
    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteFileMode: false
    })
    if (errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
    }
  }

  onCreateRemarksClick = (event) => {
    let objectCode = event.currentTarget.getAttribute('data-object-code')
    let objectId = event.currentTarget.getAttribute('data-object-id')
    this.setState({
      createMode: true,
      objectCode: objectCode,
      objectId: objectId
    })
    console.log(objectCode, objectId)
  }

  onUpdateRemarksClick = (event) => {
    let objectId = event.currentTarget.getAttribute('data-object-id')
    let date = event.currentTarget.getAttribute('data-date')
    let selectedRemarks = event.currentTarget.getAttribute('data-remarks')
    let selectedRemarksId = event.currentTarget.getAttribute('data-remarks-id')

    this.setState({
      updateRemarksMode: true,
      objectId: objectId,
      createMode: false,
      selectedDate: date,
      selectedRemarks: selectedRemarks,
      selectedRemarksId: selectedRemarksId
    })
  }

  onCpCsStatusUpdateClick = (event) => {
    let fileCode = event.currentTarget.getAttribute('data-code')
    this.setState({
      cpCsStatusUpdateMode: true,
      selectedFileCode: fileCode
    })
  }

  onInternalStatusUpdateClick = (event) => {
    let fileCode = event.currentTarget.getAttribute('data-code')
    let selectedFile = this.props.fileUploadList.filter(f => f.fileCode === fileCode)[0]
    this.setState({
      internalStatusUpdateMode: true,
      selectedFileCode: fileCode,
      selectedFile: selectedFile
    })
  }

  onMoveToCsClick = (event) => {
    event.preventDefault()
    let fileCode = event.currentTarget.getAttribute('data-row-id')
    this.setState({
      moveToCsMode: true,
      selectedFileCode: fileCode
    })
  }

  onComplianceDocsUploadClick = (event) => {
    let fileCode = event.currentTarget.getAttribute('data-code')
    this.setState({ complianceDocsUploadMode: true, selectedFileCode: fileCode })
  }

  onComplianceDocsUpload = (fileId, fileName, fileType, fileSize, othersFileName) => {
    this.setState({
      complianceDocsUploadSubmitted: true,
      complianceDocsUploadSuccessMsg: null,
      complianceDocsUploadErrorList: [],
    })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances/files/${this.state.selectedFileCode}/v2/validation`,
      this.onComplianceDocsUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      },
      othersFileName: othersFileName === undefined ? '' : othersFileName
    }
    )
  }

  onComplianceDocsUploadCallback = (response) => {
    this.setState({ complianceDocsUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      complianceDocsUploadSuccessMsg: response.success,
      complianceDocsUploadErrorList: errorList,
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          complianceDocsUploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  onComplianceDocs2UploadClick = (event) => {
    let fileCode = event.currentTarget.getAttribute('data-code')
    let userId = event.currentTarget.getAttribute('data-user-id')
    this.setState({ complianceDocs2UploadMode: true, selectedFileCode: fileCode, selectedUserId: userId })
  }

  onComplianceDocs2Upload = (fileId, fileName, fileType, fileSize) => {
    this.setState({
      complianceDocs2UploadSubmitted: true,
      complianceDocs2UploadSuccessMsg: null,
      complianceDocs2UploadErrorList: [],
    })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances/users/${this.state.selectedUserId}/files/${this.state.selectedFileCode}/v2/validation`,
      this.onComplianceDocs2UploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onComplianceDocs2UploadCallback = (response) => {
    this.setState({ complianceDocs2UploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      complianceDocs2UploadSuccessMsg: response.success,
      complianceDocs2UploadErrorList: errorList,
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          complianceDocs2UploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  onDownloadPOCounterParty = (event) => {
    let projectId = event.currentTarget.getAttribute('data-project-id')
    this.setState({ downloadPOCounterPartyRequested: true })

    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/projects/${projectId}/fileDownloadSignedUrl`,
      this.onDownloadPOCounterPartyCallback, null, null
    )
  }

  onDownloadPOCounterPartyCallback = (response) => {
    this.setState({
      downloadPOCounterPartyErrorList: response.errorList,
      downloadPOCounterPartyRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  // ---------------------------------------------------------------------------
  // Set CS Due Date handlers
  // ---------------------------------------------------------------------------

  onSetDueDateClick = (event) => {
    event.preventDefault()
    const fileCode = event.currentTarget.getAttribute('data-file-code')
    const fileTitle = event.currentTarget.getAttribute('data-file-title')
    this.setState({
      setDueDateMode: true,
      setDueDateFileCode: fileCode,
      setDueDateFileTitle: fileTitle,
    })
  }

  onSetDueDateCancel = () => {
    this.setState({
      setDueDateMode: false,
      setDueDateFileCode: null,
      setDueDateFileTitle: null,
    })
  }
}

export default ComplianceStatusSF